import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AppRoutes } from './router';
import { InquiryProvider } from './contexts/InquiryContext';
import { AuthProvider } from './contexts/AuthContext';
import { CategoryProvider } from './contexts/CategoryContext';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // hash가 있으면 해당 요소로 스크롤
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash.replace('#', ''));
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // hash 없으면 상단으로
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <CategoryProvider>
          <InquiryProvider>
            <ScrollToTop />
            <AppRoutes />
          </InquiryProvider>
        </CategoryProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
